export const formatDate = (dateObj) => {
  const date = new Date(dateObj);
  const day = date.getDate();
  const month = date.getMonth() + 1; // Month is 0-indexed
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
